
export type CreateSession500 = {
  message?: string;
  success?: boolean;
};
